// Copyright (c) Docugami, Inc. All rights reserved.

import React from 'react';
import styled from 'styled-components';
import { IGroup } from '@fluentui/react';
import { tagFont } from 'components/common/Fonts';
import { charcoalGrayText, greyText, primaryTheme } from 'components/shell/presentation/AppStyles';

const GroupedColumnContainer = styled.div.attrs({
    'data-componentname': 'GroupedColumnContainer',
})`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    background-color: ${greyText};
    align-items: center;
    padding: 0 4px;
    border-right: 1px solid ${charcoalGrayText};
`;

const GroupedColumnContent = styled.div.attrs({
    'data-componentname': 'GroupedColumnContent',
})`
    display: flex;
    align-items: center;
    max-width: 100%;
    overflow: hidden;
`;

const GroupedColumnTitle = styled.span.attrs({
    'data-componentname': 'GroupedColumnTitle',
})`
    font-family: ${tagFont};
    font-size: 13px;
    color: ${primaryTheme.palette.white};
    padding-right: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

interface GroupTitleOverlayProps {
    group: IGroup
}

const GroupTitleOverlay: React.FC<GroupTitleOverlayProps> = (props) => {
    return (
        <GroupedColumnContent>
            <GroupedColumnTitle>{props.group.name}</GroupedColumnTitle>
        </GroupedColumnContent>
    );
};

interface AgGridGroupedColumnHeaderProps {
    group: IGroup;
}

const AgGridGroupedColumnHeader: React.FC<AgGridGroupedColumnHeaderProps> = (props) => {
    return (
        <GroupedColumnContainer>
            <GroupTitleOverlay group={props.group} />
        </GroupedColumnContainer>
    );
};

export default AgGridGroupedColumnHeader;
